<template>
  <div class="page">
    <div class="pad_box">
      <div class="main_box">
        <div class="draw_box">
          <div class="ttl no_select">在此处手写签名</div>
          <div class="desc no_select">请确保与已认证的用户名保持一致，签名保持清晰可辨认</div>
          <canvas class="cvs" ref="cvs" />
        </div>
      </div>
      <div class="footer">
        <div :class="['action', empty ? 'z-dsb' : '']">
          <div
            class="btn z-reset"
            @click="reset"
          >清除</div>
          <div
            class="btn z-submit"
            @click="submit"
          >提交</div>
        </div>
      </div>
    </div>
    <img
      class="file"
      :src="filePath"
      alt="签名"
      v-if="filePath"
    />
    <Toast
      v-if="toast.status"
      @close="onToastClose"
    >{{toast.title}}</Toast>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';
import req from '../../../req';
import Toast from '../../../components/Toast.vue';

// 将base64转换为blob
function dataURLtoBlob(dataUrl) {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  const len = bstr.length;
  const u8arr = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    u8arr[i] = bstr.charCodeAt(i);
  }
  return new Blob([u8arr], { type: mime });
}

// 将blob转换为file
function blobToFile(theBlob, fileName) {
  const b = theBlob;
  b.lastModifiedDate = new Date();
  b.name = fileName;
  return b;
}

export default {
  components: { Toast },
  data() {
    return {
      empty: true,
      filePath: '',
      loading: {
        status: false,
        title: '',
      },
      toast: {
        status: false,
        title: '',
      },
    };
  },
  mounted() {
    this.pad = null;
    this.cvs = null;
    this.ctx = null;
    this.initPad();
    console.log('mounted', this.$route.query.sessionId);
  },
  methods: {
    /**
     * toast
     */
    showToast(opt = {}) {
      this.toast.status = true;
      this.toast.title = opt.title;
    },
    /**
     * toast关闭
     */
    onToastClose() {
      this.toast.status = false;
      this.toast.title = '';
    },
    /**
     * loading
     */
    showLoading(opt = {}) {
      this.loading.status = true;
      this.loading.title = opt.title;
    },
    /**
     * 关闭loading
     */
    hideLoading() {
      this.loading.status = false;
      this.loading.title = '';
    },
    initPad() {
      const that = this;
      const { cvs } = this.$refs;
      const ctx = cvs.getContext('2d');
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      cvs.width = cvs.offsetWidth * ratio;
      cvs.height = cvs.offsetHeight * ratio;
      console.log(cvs.width);
      ctx.rotate(1.5 * Math.PI);
      ctx.translate(-1 * cvs.height, 0);
      ctx.scale(ratio, ratio);
      const pad = new SignaturePad(cvs, {
        minWidth: 2,
        maxWidth: 4.5,
        onEnd() {
          const empty = pad.isEmpty();
          that.empty = empty;
        },
      });
      this.pad = pad;
      this.cvs = cvs;
      this.ctx = ctx;
    },
    back() {
      wx.miniProgram.navigateBack();
    },
    reset() {
      this.empty = true;
      this.filePath = '';
      try {
        const { pad, ctx, cvs } = this;
        pad.clear();
        ctx.fillStyle = 'rgba(0, 0, 0, 0)';
        ctx.clearRect(0, 0, cvs.height, cvs.width);
        ctx.fillRect(0, 0, cvs.height, cvs.width);
      } catch (err) {
        console.error(err);
      }
    },
    submit() {
      const that = this;
      const { empty } = this;
      if (empty) {
        return;
      }
      try {
        const res = this.pad.toDataURL();
        const file = blobToFile(dataURLtoBlob(res), 'signature.png');
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', 5);
        const {
          sessionId,
          from,
          workerPayrollId,
          rootPayrollId,
        } = this.$route.query;
        let p = null;
        if (from === 'c') {
          p = req.sys.uploadFile2c;
        } else {
          p = req.sys.uploadFile;
        }
        p(formData, {
          headers: {
            sessionId,
          },
        })
          .then((r1) => {
            console.log(r1);
            if (r1.code !== 0) {
              req.err.show(r1);
              return;
            }
            const { httpUrl, imageUrl } = r1.data;
            wx.miniProgram.postMessage({
              data: from === 'c' ? imageUrl : httpUrl,
            });
            console.log('刷脸验证', workerPayrollId);
            if (workerPayrollId) {
              const to = encodeURIComponent(`/assistSign?imageUrl=${from === 'c' ? imageUrl : httpUrl}&workerPayrollId=${workerPayrollId}`);
              const path = `/pages/webview/assist_sign/index?to=${to}`;
              console.log('刷脸验证', workerPayrollId, '跳转', `&uid=${sessionId}`, to);
              wx.miniProgram.navigateTo({ url: path });
            } else if (rootPayrollId) {
              console.log(from === 'c' ? imageUrl : httpUrl, 'rootPayrollId', rootPayrollId);
              let agreeAudit = null;
              if (from === 'c') {
                agreeAudit = req.sys.agreeAudit2c;
              } else {
                agreeAudit = req.sys.agreeAudit;
              }
              agreeAudit({
                rootPayrollId,
                signUrl: from === 'c' ? imageUrl : httpUrl,
              }, {
                headers: {
                  sessionId,
                },
              }).then((r2) => {
                if (r2.code !== 0) {
                  req.err.show(r2);
                  return;
                }
                that.showToast({
                  title: '签字成功',
                });
                setTimeout(() => {
                  that.onToastClose();
                  wx.miniProgram.navigateBack({ delta: 2 });
                }, 1500);
                // that.back();
              }).catch(req.err.show);
            } else {
              that.back();
            }
          })
          .catch((err) => {
            req.err.show(err);
          });
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .pad_box {
    position: absolute;
    left: 0;
    top: -100vw;
    width: 100vh;
    height: 100vw;
    background-color: #f3f3f7;
    transform: rotate(90deg);
    transform-origin: left bottom;
    transition: transform 1s;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .footer {
      position: relative;
      height: 2.6rem;

      .action {
        position: absolute;
        top: 50%;
        right: 1.8rem;
        transform: translate3d(0, -50%, 0);
        display: flex;

        &.z-dsb {
          opacity: 0.5;

          .z-reset {
            display: none;
          }
        }

        .btn {
          height: 2rem;
          line-height: 2rem;
          width: 4rem;
          text-align: center;
          border: 1px solid #377fee;
          border-radius: 0.35rem;
          color: #377fee;
          font-size: 0.8rem;
          font-weight: bold;
          background-color: #fff;
          box-sizing: border-box;

          &.z-submit {
            background-color: #377fee;
            color: #fff;
            margin-left: 0.8rem;
          }
        }
      }
    }

    .main_box {
      position: relative;
      flex-grow: 1;
      margin: 2.6rem 1.8rem 0 0.5rem;
      overflow: hidden;
    }

    .draw_box {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      border: 1px dashed #b4bac6;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .no_select {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .ttl {
        font-size: 2.8rem;
        line-height: 3.9rem;
        font-weight: bold;
        color: #d2d5dd;
      }

      .desc {
        margin-top: 0.4rem;
        font-size: 0.75rem;
        font-weight: bold;
        line-height: 0.9rem;
        color: #d2d5dd;
      }

      .cvs {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    .padding_bottom {
      flex-shrink: 0;
      overflow: hidden;
    }
  }

  .file {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 5rem;
  }
}
</style>
